// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"style_tooltip__M6XbA","tooltipWrapper":"style_tooltipWrapper__OsOdW","element":"style_element__i0zuE"};